module.exports = __webpack_public_path__ + "img/1-17.06b27cee.jpg";